module.exports = __webpack_public_path__ + "static/img/transition-day-of-exam.29dd349.png";